import { IAction } from "../utils";
import { reducerTypes } from "./types";
import { IPageInfo } from "../../interfaces/common";
import { IOffer } from "../../interfaces/offer";

export interface IOfferReducer {
  pageInfo: IPageInfo;
  offers: IOffer[];
  offersMore: IOffer[];
  offer?: IOffer;
  loading: boolean;
}

export const INITIAL: IOfferReducer = {
  pageInfo: {
    pageIndex: -1,
    totalPages: 0,
    totalCount: 0,
    pageSize: 12,
  },
  offers: [],
  offersMore: [],
  loading: false,
};

export const offerReducer = (state = INITIAL, { type, payload }: IAction) => {
  switch (type) {
    case reducerTypes.IS_LOADING:
      return { ...state, loading: payload };
    case reducerTypes.GET_ALL_OFFERS:
      return {
        ...state,
        offers: payload,
        offersMore: payload,
        loading: false,
      };
    case reducerTypes.GET_MORE_OFFERS:
      return {
        ...state,
        offersMore: [...state.offersMore, ...payload],
        loading: false,
      };
    case reducerTypes.GET_OFFER:
      return { ...state, offer: payload };
    case reducerTypes.SET_PAGE_INFO:
      return { ...state, pageInfo: payload };
    case reducerTypes.SET_PAGE_INDEX:
      return { ...state, pageInfo: { ...state.pageInfo, pageIndex: payload } };
    case reducerTypes.SET_PAGE_SIZE:
      return { ...state, pageInfo: { ...state.pageInfo, pageSize: payload } };
    default:
      return state;
  }
};
